// extracted by mini-css-extract-plugin
export default {"content":"TruncateWithTooltip__content___TPo4j","skeleton-loading":"TruncateWithTooltip__skeleton-loading___U7kMV"};